module.exports = __webpack_public_path__ + "static/berkeleyhaas.89f82499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/berkeleyhaas.jpg
// module id = 872
// module chunks = 169928946856436